import React, { useState } from "react";

import TextInput from "./components/TextInput";
import Button from "./components/Button";
import './styles.css';
const App = () => {
  const [albumin, setAlbumin] = useState();
  const [age, setAge] = useState();
  const [ast, setAst] = useState();
  const [plt, setPlt] = useState();
  const [alt, setAlt] = useState();

  const [fib5, setFib5] = useState();
  /*const [fib5Class, setFib5Class] = useState();*/

  const handleAlbuminChange = (event) => setAlbumin(event.target.value);
  const handleAgeChange = (event) => setAge(event.target.value);
  const handleAstChange = (event) => setAst(event.target.value);
  const handlePltChange = (event) => setPlt(event.target.value);
  const handleAltChange = (event) => setAlt(event.target.value);

  const computeFib5 = () => {
    /* let fib5Value = round((10**(0.7207-(0.6729*albumin)+(0.4408*((age*ast)/(plt*alt^0.5)))).toFixed(2))*100); */
    let euler = Math.E;
    let odds = euler**(0.7207-(0.6729*albumin)+(0.4408*((age*ast)/(plt*alt**0.5))));
    let prob = (odds/(odds+1))
    let fib5Value = round((prob*100).toFixed(2));
    setFib5(fib5Value);
    /*let fib5Class = getFib5(fib5Value);
    setFib5Class(fib5Class);*/

    setAlbumin("")
    setAge("")
    setAst("")
    setPlt("")
    setAlt("")
    
  };

  function round(num) {
    var m = Number((Math.abs(num) * 100).toPrecision(15));
    return Math.round(m) / 100 * Math.sign(num);
  };
  /* const getFib5 = (fib5) => {
    
    if (fib5 <= 10) {
      return "Low Risk (Under 10%)";
    }
    if (fib5 > 10 && fib5 <= 25) {
      return "Medium Risk (10-25%)";
    }
    if (fib5 > 25 && fib5 <= 50) {
      return "High Risk (25-50%)";
    }
    if (fib5 > 50) {
      return "This is Bad!! (>50%)";
    }
  };*/

  return (
    <div className="App">
    <div className="container">
      <div
        style={{
          display: "block",
          width: "50%",
          margin: "0 auto",
          padding: "20px",
          boxSizing: "border-box",
        }}
      >
        <h2>Welcome to the Fib4+ Calculator!</h2>
        <h3>This Website provides a Fib4+ Calculator by Rabiee et al</h3>
        <h4>Reference:</h4>
        <h4>Rabiee A, Deng Y, Ciarleglio M, Chan JL, Pons M, Genesca J, Garcia-Tsao G. Noninvasive predictors of clinically significant portal hypertension in NASH cirrhosis: Validation of ANTICIPATE models and development of a lab-based model. Hepatol Commun. 2022 Oct 10. doi: 10.1002/hep4.2091. PMID: 36214066.</h4>
        <h4><a href="https://aasldpubs.onlinelibrary.wiley.com/doi/full/10.1002/hep4.2091">Direct Link</a></h4>
        <h4><a href="https://pubmed.ncbi.nlm.nih.gov/36214066/">PubMed</a></h4>
      </div>
      <div className="row">
        <TextInput
          label="Albumin"
          placeholder="Enter Albumin in g/dL"
          handleChange={handleAlbuminChange}
          value={albumin}
        />
      </div>

      <div className="row">
        <TextInput
          label="Age"
          placeholder="Enter Age in Years"
          handleChange={handleAgeChange}
          value={age}          
        />
      </div>

       <div className="row">
        <TextInput
          label="AST"
          placeholder="Enter AST in IU/L"
          handleChange={handleAstChange}
          value={ast}          
        />
       </div>
  
        <div className="row">
        <TextInput
          label="Platelets"
          placeholder="Enter PLTs in 10^9/L"
          handleChange={handlePltChange}
          value={plt}          
        />
      </div>

        <div className="row">
        <TextInput
          label="ALT"
          placeholder="Enter ALT in IU/L"
          handleChange={handleAltChange}
          value={alt}          
        />     
      </div>

      <div className="button">
        <Button label="CALCULATE" onClick={computeFib5} />
      </div>
      
      <div className="row">
        {
          isNaN(fib5)?null:<h3>Your probability of having Clinically Significant Portal Hypertension (CSPH) is: {fib5}%</h3> 
        }
        
      </div>
      <div className="row">
        
      </div>
    </div>
    </div>
  );
};

export default App;
